<template>
    <el-drawer 
        :title="opType == 1 ? '禁言' : opType == 3 ? '注销' : '标记为黄牛' " 
        :visible.sync="punishVisible" 
        :before-close="closeDialog" 
        size="auto" 
        class="punish-box"
    >
        <div class="drawer-content">
            <el-form :model="punishForm"  ref="punishForm" label-position="top">
                <el-form-item label="处罚类型:" prop="opType">
					{{ opType == 1 ? '禁言' : opType == 3 ? '注销' : '标记为黄牛' }}
                </el-form-item>
				<el-form-item prop="day" label="处罚力度:" :rules="[{required: opType == 1 ? true : false, message: '请选择处罚力度'}]">
                    <el-select v-if="opType == 1" v-model="punishForm.day" size="medium">
                        <el-option label="3天" :value="3"></el-option>
                        <el-option label="30天" :value="30"></el-option>
                        <el-option label="90天" :value="90"></el-option>
                        <el-option label="永久" :value="0"></el-option>
                    </el-select>
                    <template v-else>永久</template>
				</el-form-item>
                <el-form-item v-if="opType == 1" label="评论处理:" prop="shieldLetter">
                    <el-checkbox v-model="punishForm.shieldLetter" :true-label="1" :false-label="0">屏蔽掉用户所有评论</el-checkbox>
                </el-form-item>
				<el-form-item  prop="desc" label="备注:">
					<el-input v-model="punishForm.desc" :rows="2" type="textarea" size="medium"  maxlength="100"></el-input>
				</el-form-item>                
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm" :loading="submitLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    opType: '',
    day: 0,
    desc: '',
    id:''
}
export default {
    props: {
        punishVisible: {
            type: Boolean,
            default: false
        },
		editData: {
            type: Object,
            default: null
        },
        opType:{
            type:Number,
            default:1
        }
    },
    data(){       
      return {
		submitLoading: false,		
        punishForm: {
            ...defaultFormData
		}    	
      }  
    },
    watch:{
        punishVisible(v){
            if(v){
                this.punishForm = {
                    ...defaultFormData,
                    id:this.editData.id,
                    opType:this.opType,
                    day: this.opType == 1 ? '' : 0,
                    shieldLetter: this.opType == 1 ? 1 : 0,
                }
            }
        }
    },
    methods: {
        submitForm(){
			
            this.$refs['punishForm'].validate((valid) => {
                if(valid){
                    this.submitLoading = true;
                    this.$request({
                        url: '/userPunish/setPunish',
                        method: "POST",
                        data: {...this.punishForm }
                    }).then(res=>{
                        const {state, msg} = res.data;
                        if (state == 1) {
                            this.$message.success('操作成功');
                            this.closeDialog();
                            this.$emit('onUpdate');
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    }).catch(() => {
                        this.$message.error("请求错误");
                    }).finally(()=>{
                        this.submitLoading = false;
                    })
                }
            })            
        },
        closeDialog(){
            this.$emit('update:punishVisible', false);
            // this.$nextTick(()=>{
                this.$refs['punishForm'].clearValidate();   
                this.$refs['punishForm'].resetFields();
            // })              
        }
    }
}
</script>